import { createContext, useContext } from "react";

import { type Address } from "@/components/address-search";

interface AddressFieldsContextType {
  fillAddressFields: (address: Address) => void;
}

export const AddressFieldsContext = createContext<
  AddressFieldsContextType | undefined
>(undefined);

export const useAddressFields = () => {
  const context = useContext(AddressFieldsContext);
  if (!context) {
    throw new Error(
      "useAddressFields must be used within AddressFieldsProvider"
    );
  }
  return context;
};
